import { render } from "./UserCourseChoice.vue?vue&type=template&id=759ba53e&scoped=true"
import script from "./UserCourseChoice.vue?vue&type=script&lang=js"
export * from "./UserCourseChoice.vue?vue&type=script&lang=js"

import "./UserCourseChoice.vue?vue&type=style&index=0&id=759ba53e&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759ba53e"]])

export default __exports__